<div *ngIf="!hidden"
    class="flex w-full h-full items-center justify-center fixed top-0 left-0 right-0 bottom-0 z-[9999] overflow-hidden">
    <div class="bg-slate-900 w-full h-full opacity-60 absolute top-0 left-0 right-0 bottom-0"></div>
    <div
        class="flex flex-col rounded-2xl bg-white shadow-2xl relative z-10 max-w-5xl w-11/12 max-h-[90vh] overflow-hidden">
        <div
            class="bg-gradient-to-r from-orange-500 to-orange-600 p-5 text-center text-2xl font-bold text-white flex items-center justify-center gap-3 shadow-lg">
            <mat-icon class="!text-[36px] !w-[36px] !h-[36px] animate-pulse">warning</mat-icon>
            <span>ACTION REQUISE – Vos boîtiers 2G doivent être remplacés</span>
        </div>

        <!-- Main Content Area -->
        <div class="flex flex-row flex-1 overflow-hidden" style="min-height: 0;">
            <!-- Left Side - Description -->
            <div
                class="flex flex-col gap-6 p-8 w-2/3 border-r-2 border-gray-100 bg-gradient-to-br from-white to-tachosafe-50/30 overflow-y-auto">
                <!-- Icon and description -->
                <div class="flex items-start gap-4">
                    <div class="flex-shrink-0 bg-tachosafe-100 rounded-xl p-3">
                        <mat-icon class="text-tachosafe-600 !text-[56px] !w-[56px] !h-[56px]">cell_tower</mat-icon>
                    </div>
                    <div class="flex flex-col gap-3">
                        <p class="text-base leading-relaxed text-gray-700">
                            Les opérateurs mobiles procèdent actuellement à l'arrêt progressif de leurs réseaux 2G en
                            France, dont l'extinction sera généralisée d'ici fin 2026.
                        </p>
                        <p class="text-base font-semibold text-gray-900">
                            Un ou plusieurs boîtiers 2G de votre flotte sont concernés et doivent être remplacés par une
                            version 4G/LTE afin de maintenir le service.
                        </p>
                    </div>
                </div>

                <!-- Support section -->
                <div
                    class="flex items-start gap-4 bg-gradient-to-br from-tachosafe-50 to-tachosafe-100 p-5 rounded-xl shadow-sm border border-tachosafe-200">
                    <div class="flex-shrink-0 bg-white rounded-lg p-2">
                        <mat-icon class="text-tachosafe-600 !text-[44px] !w-[44px] !h-[44px]">handshake</mat-icon>
                    </div>
                    <div class="flex flex-col gap-2">
                        <p class="text-base font-bold text-tachosafe-900">Nous vous accompagnons dans cette migration
                        </p>
                        <p class="text-sm text-gray-800 leading-relaxed">
                            Pour vous aider à réduire le coût de cette transition, TACHOSAFE vous accorde une <span
                                class="font-semibold text-tachosafe-700">remise de 30 € HT</span>
                            pour chaque boîtier 2G remplacé. Vous pouvez également profiter de cette migration pour
                            passer au
                            <span class="font-semibold text-tachosafe-700">boitier RDU-GPS 4G</span>, qui combine
                            téléchargement à distance et géolocalisation, sans surcoût matériel par rapport au boitier
                            standard.*
                        </p>
                    </div>
                </div>

                <p
                    class="text-sm font-semibold text-gray-900 bg-yellow-50 border-l-4 border-yellow-400 p-3 rounded-r-lg">
                    Afin de bénéficier de cette offre, complétez cette demande de migration. Vous serez ensuite contacté
                    afin de finaliser le processus.
                </p>

                <p class="text-xs text-gray-600 italic">
                    *Abonnement mensuel au service de géolocalisation en supplément
                </p>
            </div>

            <!-- Right Side - Vehicle List -->
            <div class="flex flex-col w-1/3 bg-gradient-to-br from-gray-50 to-white">
                <div class="p-6 pb-4">
                    <h3 class="text-xl font-bold text-tachosafe-900 mb-3 flex items-center gap-2">
                        <mat-icon class="text-tachosafe-600 !text-[28px] !w-[28px] !h-[28px]">directions_car</mat-icon>
                        Véhicules concernés
                    </h3>
                    <p class="text-sm text-gray-700 leading-relaxed">
                        Décochez les véhicules que vous ne souhaitez pas migrer.
                    </p>
                </div>

                <!-- Scrollable vehicle list -->
                <div class="flex-1 overflow-y-auto px-6 pb-4">
                    <!-- Loading spinner -->
                    <div *ngIf="loadingTerminals" class="flex items-center justify-center py-12">
                        <mat-spinner diameter="50"></mat-spinner>
                    </div>

                    <!-- No terminals message -->
                    <div *ngIf="!loadingTerminals && terminals.length === 0"
                        class="flex items-center justify-center py-12 text-gray-500">
                        <p>Aucun terminal trouvé</p>
                    </div>

                    <!-- Terminal list -->
                    <div *ngIf="!loadingTerminals && terminals.length > 0"
                        class="flex flex-col border border-gray-200 rounded-lg overflow-hidden">
                        <div *ngFor="let terminal of terminals; let last = last"
                            class="flex items-center gap-3 p-3 hover:bg-tachosafe-50 transition-all duration-200 bg-white"
                            [class.border-b]="!last" [class.border-gray-200]="!last">
                            <mat-checkbox color="primary" [(ngModel)]="terminal.selected"
                                (click)="$event.stopPropagation()"></mat-checkbox>
                            <span class="font-semibold text-gray-800 flex-1">{{ getDisplayName(terminal) }}</span>
                        </div>
                    </div>
                </div>

                <!-- GPS Interest Checkbox - Fixed at bottom -->
                <div class="px-6 pb-6 border-t border-gray-200 bg-white">
                    <div
                        class="flex items-center gap-3 bg-tachosafe-50 border border-tachosafe-200 rounded-lg p-4 mt-4">
                        <mat-checkbox color="primary" [(ngModel)]="gpsInterested"></mat-checkbox>
                        <span class="text-xs text-gray-600">Cochez RDU-GPS si cette option vous intéresse</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Bottom - Contact Form -->
        <div class="border-t-2 border-gray-200 bg-gradient-to-br from-gray-50 to-tachosafe-50/20 px-4 py-3">
            <div class="flex items-center gap-2 mb-2">
                <div class="flex-shrink-0 bg-tachosafe-100 rounded-md p-1.5">
                    <mat-icon class="text-tachosafe-600 !text-[24px] !w-[24px] !h-[24px]">contact_mail</mat-icon>
                </div>
                <div class="flex-1">
                    <h3 class="text-base font-bold text-tachosafe-900 mb-0.5">
                        Vos coordonnées
                    </h3>
                    <p class="text-[11px] text-gray-600 leading-tight">Veuillez fournir vos coordonnées afin que nous puissions vous accompagner dans le processus de migration.</p>
                </div>
            </div>

            <div class="grid grid-cols-3 gap-2 mb-2">
                <div class="flex flex-col">
                    <label class="text-[11px] font-semibold text-gray-700 mb-0.5">Nom *</label>
                    <input type="text" [(ngModel)]="contactName"
                        [class.border-red-500]="contactName && contactName.trim() === ''"
                        [class.border-tachosafe-400]="contactName && contactName.trim() !== ''"
                        class="border border-gray-300 rounded-md p-1.5 text-xs focus:outline-none focus:ring-1 focus:ring-tachosafe-500 focus:border-transparent transition-all duration-200 bg-white"
                        placeholder="Votre nom complet" required>
                    <span *ngIf="contactName && contactName.trim() === ''"
                        class="text-red-500 text-[10px] mt-0.5 font-medium">
                        Le nom est requis
                    </span>
                </div>

                <div class="flex flex-col">
                    <label class="text-[11px] font-semibold text-gray-700 mb-0.5">Email *</label>
                    <input type="email" [(ngModel)]="contactEmail" [class.border-red-500]="getEmailError()"
                        [class.border-tachosafe-400]="contactEmail && !getEmailError()"
                        class="border border-gray-300 rounded-md p-1.5 text-xs focus:outline-none focus:ring-1 focus:ring-tachosafe-500 focus:border-transparent transition-all duration-200 bg-white"
                        placeholder="votre@email.com" required>
                    <span *ngIf="getEmailError()" class="text-red-500 text-[10px] mt-0.5 font-medium">
                        Veuillez entrer une adresse email valide
                    </span>
                </div>

                <div class="flex flex-col">
                    <label class="text-[11px] font-semibold text-gray-700 mb-0.5">Téléphone *</label>
                    <input type="tel" [(ngModel)]="contactPhone" [class.border-red-500]="getPhoneError()"
                        [class.border-tachosafe-400]="contactPhone && !getPhoneError()"
                        class="border border-gray-300 rounded-md p-1.5 text-xs focus:outline-none focus:ring-1 focus:ring-tachosafe-500 focus:border-transparent transition-all duration-200 bg-white"
                        placeholder="06 12 34 56 78" required>
                    <span *ngIf="getPhoneError()" class="text-red-500 text-[10px] mt-0.5 font-medium">
                        Veuillez entrer un numéro de téléphone valide (minimum 7 chiffres)
                    </span>
                </div>
            </div>

            <!-- Action Buttons -->
            <div class="flex items-center justify-center gap-3">
                <button (click)="dismissModal()" [disabled]="submittingRequest"
                    [class.opacity-50]="submittingRequest" [class.cursor-not-allowed]="submittingRequest"
                    class="rounded-lg bg-gray-500 px-6 py-2 font-semibold text-xs text-white transition-all duration-300 hover:bg-gray-600 hover:shadow-md transform hover:scale-105 disabled:hover:bg-gray-500 disabled:transform-none disabled:shadow-none">
                    Me le rappeler plus tard
                </button>
                <button (click)="submitContactInfo()" [disabled]="!isFormValid() || submittingRequest"
                    [class.opacity-50]="!isFormValid() || submittingRequest"
                    [class.cursor-not-allowed]="!isFormValid() || submittingRequest"
                    class="rounded-lg bg-gradient-to-r from-tachosafe-600 to-tachosafe-700 px-6 py-2 font-semibold text-xs text-white transition-all duration-300 hover:from-tachosafe-700 hover:to-tachosafe-800 hover:shadow-md transform hover:scale-105 disabled:hover:from-tachosafe-600 disabled:hover:to-tachosafe-700 disabled:transform-none disabled:shadow-none flex items-center justify-center gap-2">
                    <mat-spinner *ngIf="submittingRequest" diameter="16" class="inline-block"></mat-spinner>
                    <span>{{ submittingRequest ? 'Envoi en cours...' : 'Envoyer ma demande' }}</span>
                </button>
            </div>
        </div>
    </div>
</div>
